import React from "react";
import Listar from "./Listar";
import authAxios from "../../services/Token";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
class Index extends React.Component {
	constructor(props) {
		super(props);
	}
	state = {
		enproceso: 0,
		congelado: 0,
		aprobado: 0,
		anulado: 0,
		contrato_no: 0,
		contrato_si: 0,
		cant_pro: 0,
		cant_mat: 0,
		ListaPqr: [],
	};
	dashboard() {
		Swal.showLoading();
		var idu = localStorage.getItem("idusuario");

		authAxios
			.get("configuracion/menu_principal/" + idu)
			.then((datosRespuesta) => {
				console.log(datosRespuesta);
				Swal.close();
				var status = datosRespuesta.data.status;
				var d = datosRespuesta.data;
				if (status) {
					Swal.fire('Token has Expired!', 'Re-Login', 'info');
					window.localStorage.clear();
					window.location.href = "/";
				}
				this.setState({
					cant_pro: d.result_pro,
					cant_mat: d.result_mat,
					enproceso: d.enproceso,
					congelado: d.congelado,
					aprobado: d.aprobado,
					anulado: d.anulado,
					contrato_no: d.contrato_no,
					contrato_si: d.contrato_si,
					ListaPqr: d.pqr,
				});
			})
			.catch(console.log);
	}
	componentDidMount() {
		this.dashboard();
	}
	render() {
		const {
			enproceso,
			congelado,
			aprobado,
			anulado,
			contrato_no,
			contrato_si,
			ListaPqr,
			cant_pro,
			cant_mat,
		} = this.state;
		return (
			<div>
				<div className="content-wrapper">
					<div className="content-header">
						<div className="container-fluid">
							<div className="row mb-2">
								<div className="col-sm-6">
									<h1 className="m-0">Dashboard</h1>
								</div>
								<div className="col-sm-6">
									<ol className="breadcrumb float-sm-right">
										<li className="breadcrumb-item">
											<a href="/home">Home</a>
										</li>
										<li className="breadcrumb-item active">Dashboard v1</li>
									</ol>
								</div>
							</div>
						</div>
					</div>
					<section className="content">
						<div className="container-fluid">
							<div className="row">
								{/* <section className="col-lg-12 connectedSortable">
									<div className="card">
										<div className="card-header text-center">
											&nbsp;
										</div>
										<div className="card-body">
											<h4>Last Invoices</h4>
                            				<hr />
											<div className="row">
												<div className="col-xl-12">
													<table className="table table-hover table-condensed table-sm">
														<thead className="thead-inverse">
															<tr>
																<th className="align-middle">INVOICE ID</th>
																<th className="align-middle">CLIENT</th>
																<th className="align-middle">EMAIL</th>
																<th className="align-middle">DATE</th>
																<th className="align-middle">TOTAL</th>
																<th className="align-middle">STATUS</th>
																<th className="align-middle">ACTION</th>
															</tr>
														</thead>
													</table>
												</div>
											</div>
										</div>
										<div className="card-footer clearfix">
											&nbsp;
										</div>
									</div>
								</section>
								<div className="col-lg-4 col-8">
									<div style={{ backgroundColor: '#00539B', color: '#FFFFFF' }} className="small-box">
										<div className="inner">
											<h3>{enproceso}</h3>
											<p>In Process</p>
										</div>
										<div className="icon">
											<i className="fas fa-dollar-sign" />
										</div>
										<a href="#" className="small-box-footer">
											Quotations <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-4 col-8">
									<div style={{ backgroundColor: '#198754', color: '#FFFFFF' }} className="small-box">
										<div className="inner">
											<h3>{enproceso}</h3>
											<p>Approved</p>
										</div>
										<div className="icon">
											<i className="fas fa-dollar-sign" />
										</div>
										<a href="#" className="small-box-footer">
											Quotations <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-4 col-8">
									<div style={{ backgroundColor: '#DC3545', color: '#FFFFFF' }} className="small-box">
										<div className="inner">
											<h3>{enproceso}</h3>
											<p>Canceled</p>
										</div>
										<div className="icon">
											<i className="fas fa-dollar-sign" />
										</div>
										<a href="#" className="small-box-footer">
											Quotations <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-4 col-8">
									<div style={{ backgroundColor: '#00539B', color: '#FFFFFF' }} className="small-box">
										<div className="inner">
											<h3>{cant_pro}</h3>
											<p>In Process</p>
										</div>
										<div className="icon">
											<i className="fas fa-dollar-sign" />
										</div>
										<a href="#" className="small-box-footer">
											Invoices <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-4 col-8">
									<div style={{ backgroundColor: '#20C997', color: '#FFFFFF' }} className="small-box">
										<div className="inner">
											<h3>{cant_mat}</h3>
											<p>Partial Paid</p>
										</div>
										<div className="icon">
											<i className="fas fa-dollar-sign" />
										</div>
										<a href="#" className="small-box-footer">
											Invoices <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-4 col-8">
									<div style={{ backgroundColor: '#198754', color: '#FFFFFF' }} className="small-box">
										<div className="inner">
											<h3>{cant_mat}</h3>
											<p>Total Paid</p>
										</div>
										<div className="icon">
											<i className="fas fa-dollar-sign" />
										</div>
										<a href="#" className="small-box-footer">
											Invoices <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div> */}
							</div>
						</div>
					</section>
				</div>
			</div>
		);
	}
}

export default Index;
